import { createFileRoute } from '@tanstack/react-router'
import { BODY_FONT, HEADING_FONT } from '@/lib/constants'
import { COLORS, GUTTER } from '@/components/home/tokens'
import { useIsMobile } from '@/lib/hooks'
import AshbyJobBoard from '@/components/AshbyJobBoard'

export const Route = createFileRoute('/joinus')({
  component: JoinUsPage,
})

function JoinUsPage() {
  const isMobile = useIsMobile()

  return (
    <div
      style={{
        minHeight: '100vh',
        // Top padding clears the fixed 88px header; the board grows tall, so
        // the page flows from the top rather than vertically centering.
        padding: isMobile ? `15vh 24px 100px` : `136px ${GUTTER} 100px`,
        position: 'relative',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ width: '100%', maxWidth: 1100, margin: '0 auto' }}>
        {/* Heading (platform hero styles) */}
        <h1
          style={{
            fontFamily: HEADING_FONT,
            fontWeight: 200,
            fontSize: 'var(--text-4xl)',
            lineHeight: 1.2,
            letterSpacing: '-0.02em',
            color: COLORS.neutral2,
            margin: 0,
            textAlign: 'center',
          }}
        >
          We&apos;re building for what&apos;s next.
        </h1>
        <p
          style={{
            fontFamily: BODY_FONT,
            fontSize: 'var(--text-base)',
            lineHeight: 1.55,
            color: COLORS.neutral4,
            maxWidth: '44ch',
            margin: '32px auto 0',
            textAlign: 'center',
          }}
        >
          If you&apos;re excited about solving hard problems, taking ownership, and shaping the future of security, apply here.
        </p>

        {/* Ashby job board — full board (listings → posting → application),
            rendered inside a cross-origin iframe that submits candidate data
            directly to Ashby; it never touches our servers, so it loads
            regardless of cookie consent. Styled to the Ent design system via
            /ashby-form.css. minHeight reserves space for the async-injected
            iframe so the footer doesn't shift up while it loads (CLS). */}
        <div style={{ marginTop: 56, minHeight: 600 }}>
          <AshbyJobBoard />
        </div>
      </div>
    </div>
  )
}
